import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Paperclip, Bell, Template } from "tabler-icons-react";
import { Notification } from "@mantine/core";
import Logo from "./SecondaryLogo.png";
import Section2 from "../components/AfterLogin/Section2/Section2";
import Section3 from "../components/AfterLogin/Section3/Section3";
import AppHeader from "../components/Header/AppHeader";
import { getCookiesSession } from "../cookiesSession";

const LandingPageAfterLogin = () => {
  const navigate = useNavigate();
  const [configs, setConfigs] = useState({
    loading: true,
    userData: null,
  });
  useEffect(() => {
    const userData = getCookiesSession("masterResult");
    if (userData) {
      setConfigs({
        loading: false,
        userData: userData,
      });
    } else {
      navigate("/login");
      setConfigs({
        loading: false,
        userData: null,
      });
    }
  }, []);
  let userData = getCookiesSession("masterResult");
  console.log("userData in choosemanager: ", userData);
  console.log("configs: ", configs);
  return (
    <div className="choose-manager-page">
      {!configs.loading ? (
        <div className="w-full relative flex flex-col">
          <AppHeader hide={true} />
          {/* <LandingPageHeader /> */}
          <div className="landing-logo-container">
            <img src={Logo} alt="LawSigna" className="landing-logo" />
          </div>
          <Section2 />
          {/* <Section3 /> */}
        </div>
      ) : (
        <div>Loading ...</div>
      )}
    </div>
  );
};

export default LandingPageAfterLogin;
